
export const GET_IP = "https://myip.cisc.workers.dev";
export const GET_INFO = "https://info.cisc.workers.dev";
export const PASSWORD = "ipsecurity";